// extracted by mini-css-extract-plugin
module.exports = {"brickXStatisticsBar":"_1ckpi","brickXStatisticsBarInner":"_28Ryr","statistic":"_3Z_De","statisticValue":"_24eT3","statisticName":"_2Ev9d"};